export enum EinreichungRoute {
  AddApplications = 'antrag-hinzufügen',
  AddApplicationsList = 'antrag-wählen',
  UploadAttachments = 'anhang-hinzufügen',
  AddEnclosures = 'anlage-hinzufügen',
  AddEnclosuresList = 'anlage-wählen',
  DeleteDateInfo = 'loeschdatum-info',
  DeleteDocument = 'dokument-löschen',
  DeleteApplicationConfirmation = 'antrag-löschen',
  EditForm = 'formular-bearbeiten',
  OldAntrag = 'antrag-old',
  Summary = 'zusammenfassung',
  Gallery = 'gallery',
  Assistant = 'assistent',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  AssistantAddApplications = 'antrag-hinzufügen',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  AssistantAddEnclosures = 'anlage-hinzufügen',
  AssistantCancelConfirmation = 'assistent-schliessen',
  AssistantChooseContainer = 'antrag-waehlen',
  AssistantDataPrivacy = 'datenschutz',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  AssistantSummary = 'zusammenfassung',
  AssistantWelcome = 'start',
  DeleteAnlageConfirmation = 'delete-anlage-confirmation',
}
